module.exports = __webpack_public_path__ + "static/img/5.17b9224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 1